import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateMarriageInfo = ({ christian, onUpdate, onCancel }) => {
  const [formData, setFormData] = useState({
    church_wedding: '',
    church_wedding_date: '',
    church_wedding_parish: '',
    civil_wedding: '',
    civil_wedding_date: ''
  });

  useEffect(() => {
    if (christian) {
      setFormData({
        church_wedding: christian.church_wedding || '',
        church_wedding_date: christian.church_wedding_date || '',
        church_wedding_parish: christian.church_wedding_parish || '',
        civil_wedding: christian.civil_wedding || '',
        civil_wedding_date: christian.civil_wedding_date || ''
      });
    }
  }, [christian]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        formData
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating marriage info:", error);
      alert("Failed to update marriage info. Check console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.church_wedding}
          </label>
          <select
            name="church_wedding"
            value={formData.church_wedding}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select church wedding status</option>
            <option value="Yego">Yes</option>
            <option value="Oya">No</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.church_wedding_date}
          </label>
          <input
            type="date"
            name="church_wedding_date"
            value={formData.church_wedding_date}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.church_wedding_parish}
          </label>
          <input
            type="text"
            name="church_wedding_parish"
            value={formData.church_wedding_parish}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.civil_wedding}
          </label>
          <select
            name="civil_wedding"
            value={formData.civil_wedding}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            <option value="">Select civil wedding status</option>
            <option value="Yego">Yes</option>
            <option value="Oya">No</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            {data.allChristianTable.civil_wedding_date}
          </label>
          <input
            type="date"
            name="civil_wedding_date"
            value={formData.civil_wedding_date}
            onChange={handleChange}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Save Changes
        </button>
      </div>
    </form>
  );
};

export default UpdateMarriageInfo;